const handleCopyToClipboard = async (textoToCopy: string) => {
  if ('clipboard' in navigator) {
    await navigator.clipboard.writeText(`${textoToCopy}`)
  } else {
    document.execCommand('copy', true, `${textoToCopy}`)
  }
}

export default handleCopyToClipboard
